// extracted by mini-css-extract-plugin
module.exports = {"btnGreenIconText":"BtnGreenIconText_btnGreenIconText__Urua1","text":"BtnGreenIconText_text__3Jk-N","icon":"BtnGreenIconText_icon__cqb2W"};